import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)`
  overflow-x: hidden;
  overflow-y: visible;
  width: 100%;
`;
